<script setup lang="ts">
import CloseButton from "./CloseButton.vue";

defineProps<{
  label: string;
}>();

const emits = defineEmits(["onClose"]);

const handleOnClose = () => {
  emits("onClose");
};
</script>

<template>
  <div class="flex flex-col justify-center gap-2">
    <div class="gap-px-12 flex items-center justify-between">
      <!-- t-sh3 (20px semibold) rather than t-h4 (20px extralight): same size, but the new design
           language sets headings semibold — see the section headings in navigation/*.vue. -->
      <h4 class="t-sh3 text-type-default">{{ label }}</h4>
      <CloseButton @click="handleOnClose" />
    </div>
  </div>
</template>
